import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ImageService {
  constructor() { }

  public resizeImage(image: File): Promise<File> {

    return new Promise((resolve) => {

      const fileReader = new FileReader();
      const newImage = new Image();
      fileReader.addEventListener(
        'load',
        () => {
          newImage.src = fileReader.result.toString();
          newImage.onload = () => {
            const canvas = document.createElement('canvas');
            let width = newImage.width;
            let height = newImage.height;
            width = width * (400 / height);
            height = 400;

            //Draw canvas containing imagg
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(newImage, 0, 0, width, height);
            canvas.toBlob(
              (blob) => {
                resolve(new File([blob], 'picture.jpeg', { type: 'image/jpeg' }));

              },
              'image/jpeg',
              1
            );
          }
        }
      );
      if (image) {
        fileReader.readAsDataURL(image);
      }

    });
  }
}
